/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {LineItemContextActionsComponent} from '../line-item/line-item-context-actions.component';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';
import {emptyRouteView} from '../common/directives/html/route-view-components';

const listTemplate = '<adn-ax-line-item-list-page [list]="list"></adn-ax-line-item-list-page>';



export function axLineItemStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterHelper('ax-line-items.ax-line-item', LineItemResource, 'app.adv', 'app', listTemplate);
    
        $stateProvider.state(rh.listPath(), rh.list({
          resolve: {
            listConfig: function() {
              return {moreParams: {excludeIfMissing: 'axProductId'}};
            }
          },
          views: {
            'context@app': emptyRouteView()
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            resolve: {
              advertiserFromParam: function() {},
              orderFromParam: function() {},
              lineItemView: /*@ngInject*/ function($stateParams) {
                const dataViewResource = adnRouterHelper.services.dataViewResource();

                if (!$stateParams.isNew) {
                  return dataViewResource.get('LineItemView', {id: $stateParams.id || 'undefined-id'}, false);
                }
              },
              full: function() {
                return false;
              },
              viewType: function() {
                return 1;
              },
              lineItemEditRouteKey: function() {
                return 'line-item-edit';
              },
              routeEditVariant: function() {
                return 'edit';
              },
              axLineItemEditInputs: /*@ngInject*/ function(
                full, viewType, orderFromParam, advertiserFromParam, lineItemView
              ) {
                return {full, viewType, orderFromParam, advertiserFromParam, lineItemView};
              },
              model: /*@ngInject*/ function($stateParams) {
                return adnRouterHelper.services.resource(LineItemResource).get({id: $stateParams.id}).$promise;
              }
            },
            views: {
              'content@app': {
                component: AdminResourceItemRoutePageComponent,
                bindings: {
                  item: 'lineItemEditRouteKey',
                  variant: 'routeEditVariant',
                  inputOverrides: 'axLineItemEditInputs'
                }
              },
              'context@app': {
                component: LineItemContextActionsComponent,
                bindings: {model: 'model', modelComms: 'modelComms', isNew: 'isNew', readOnly: 'readOnly'}
              }
            }
          }, 'LineItem', [{type: 'Advertiser', func: 'canBeShownAdvertiser'}, {type: 'Order', func: 'isNotSelfService'}]));
  }, adnRouterHelper);
}
